import Vue from 'vue'
import Vuex from 'vuex'

import {
    localAxios,
} from '@/helpers/axios'
import _auth from '@/helpers/api/auth/index'
import _services from '@/helpers/api/services/index'
import _clients from '@/helpers/api/clients/index'
import _administrators from '@/helpers/api/administrators/index'
import _requests from '@/helpers/api/requests/index'
import _orders from '@/helpers/api/orders/index'
import _partners from '@/helpers/api/partners/index'
import _notifications from '@/helpers/api/notifications/index'
import _specialists from '@/helpers/api/specialists/index'
import _metrics from '@/helpers/api/metrics/index'
import _badges from '@/helpers/api/badges/index'
import _chat from '@/helpers/api/chat/index'
import _materials from '@/helpers/api/materials/index'
import _problems from '@/helpers/api/problems/index'
import _todo from '@/helpers/api/todo/index'
import _files from '@/helpers/api/files/index'
import _offices from '@/helpers/api/offices/index'
import _tools from '@/helpers/api/tools/index'
import _skills from '@/helpers/api/skills/index'
import _tags from '@/helpers/api/tags/index'
import _pdf from '@/helpers/api/pdf/index'

import '@/helpers/config/index'

function inject(key, data, object) {
    Object.defineProperty(object, key, {
        get() {
            return data
        },
        set(v) {
            return v
        },
    })
}

function appendToVue(repositories) {
    inject('$api', repositories, Vue.prototype)
    inject('$api', repositories, Vuex.Store.prototype)
}

function init() {
    const axios = localAxios

    const auth = _auth(axios)
    const services = _services(axios)
    const clients = _clients(axios)
    const administrators = _administrators(axios)
    const requests = _requests(axios)
    const orders = _orders(axios)
    const partners = _partners(axios)
    const notifications = _notifications(axios)
    const specialists = _specialists(axios)
    const metrics = _metrics(axios)
    const badges = _badges(axios)
    const chat = _chat(axios)
    const materials = _materials(axios)
    const problems = _problems(axios)
    const todo = _todo(axios)
    const files = _files(axios)
    const offices = _offices(axios)
    const tags = _tags(axios)
    const skills = _skills(axios)
    const tools = _tools(axios)
    const pdf = _pdf(axios)

    const repositories = {
        auth,
        services,
        clients,
        administrators,
        requests,
        orders,
        partners,
        notifications,
        specialists,
        metrics,
        badges,
        chat,
        materials,
        problems,
        todo,
        files,
        offices,
        tags,
        skills,
        tools,
        pdf,
    }

    appendToVue(repositories)

    return repositories
}

export default {
    repositories: init(),
}
